import { isSFTT } from './isCheck';

export const BLACK = '#000000';
export const TEXT_GREY = '#AFAEAE';
export const DARK_TEXT_GREY = '#646464';
export const PALE_GREY = '#D9D9D9';
export const LIGHT_GREY = '#E5E5E5';
export const BACKGROUND_GREY = '#F3F3F3';
export const DARK_GREY = '#444444';
export const DARK_GREEN = isSFTT() ? '#3A681A' : '#1a4b68';
export const MID_GREEN = isSFTT() ? '#61802E' : '#2e5b80';
export const LIGHT_GREEN = isSFTT() ? '#9AC356' : '#569bc3';
export const PALE_GREEN = '#E5EBDA';
export const BACKGROUND_GREEN = '#D4EDAA';
export const WHITE = '#FFFFFF';
export const RED = '#FF0000';
export const LIGHT_RED = '#D07B69';
export const PINK = '#FFD1D1';

// Map Colors
export const MAP_GREEN = '#117733';
export const MAP_YELLOW = '#DDCC77';
export const MAP_RED = '#882255';
